import {
    CalendarEvent,
    CalendarEventAction,
    CalendarEventTimesChangedEvent
  } from 'angular-calendar';
import { FormBuilder, FormGroup } from '@angular/forms';

export interface Calendar
{
    calendar_id:string,
    event_id:number,
    title:string,
    start:Date,
    end:Date,
    email:string,
    alocation:string,
    description:string,
    summview:string,
    startlimit:string,
    endlimit:string,
    className:string
}

export interface HTTPCalendar
{
    calendar_id:string,
    event_id:number,
    title:string,
    start:Date,
    end:Date,
    email:string,
    alocation:string,
    description:string,
    summview:string,
    startlimit:string,
    endlimit:string,
    className:string
}

export class CalendarForm implements HTTPCalendar{

    public calendar_id:string;
    public event_id:number;
    public title:string;
    public start:Date;
    public end:Date;
    public email:string;
    public alocation:string;
    public description:string;
    public summview:string; 
    public startlimit:string; 
    public endlimit:string;
    public className:string;  

    constructor(data : Calendar) 
    {
        if(data==null)
        {
            this.calendar_id="";
            this.event_id=-1;
            this.title="";
            this.start=new Date();
            this.end=new Date();
            this.email="";
            this.alocation="";
            this.description="";
            this.summview="";
            this.startlimit="";
            this.endlimit="";
            this.className="";
        }
        else
        {
            this.calendar_id=data.calendar_id;
            this.event_id=data.event_id;
            this.title=data.title;
            this.start=new Date(data.start);
            this.end=new Date(data.end);
            this.email=data.email;
            this.alocation=data.alocation;
            this.description=data.description;
            this.summview=data.summview;
            this.startlimit=data.startlimit;
            this.endlimit=data.endlimit;
            this.className=data.className;
        }
    }

    public MakeEvent(data:Calendar[], action:CalendarEventAction[], colors:any):CalendarEvent[]
    {
        console.log(data);
        let ret:CalendarEvent[]=[];
        colors= {
            green: {
              primary: '#0ca12e',
              secondary: '#0ca12e'
            },
            yellow: {
              primary: '#D88E08',
              secondary: '#D88E08'
            },
            blue: {
              primary: '#3a87ad',
              secondary: '#3a87ad'
            }
          };
        for(let row of data)
        {
            let eventcolor:any=colors.blue;
            if(row.className=='green')
                eventcolor=colors.green;
            else if(row.className=='yellow')
                eventcolor=colors.yellow;
            else if(row.className=='blue')
                eventcolor=colors.blue;
            
            let tmp:CalendarEvent={
                id: row.event_id,
                 title:'<b>'+row.title+'</b> :<br/>'+row.summview,
                start: new Date(row.start),
                end: new Date(row.end),
                //email:row.email,
                //location:row.alocation,
                //description:row.description,
              //  summview:row.summview,
                color: eventcolor,
                actions: action
            };

            ret.push(tmp);
        }
        return ret;
    }

    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            calendar_id: [this.calendar_id],
            event_id: [this.event_id],
            title: [this.title],
            start: [this.start],
            end: [this.end],
            email: [this.email],
            alocation: [this.alocation],
            description: [this.description],
            summview: [this.summview],
            startlimit: [this.startlimit],
            endlimit: [this.endlimit]
        });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.calendar_id=fg.get("calendar_id").value;
            this.event_id=fg.get("event_id").value;
            this.title=fg.get("title").value;
            this.start=fg.get("start").value;
            this.end=fg.get("end").value;
            this.email=fg.get("email").value;
            this.alocation=fg.get("alocation").value;
            this.summview=fg.get("summview").value;
            this.startlimit=fg.get("startlimit").value;
            this.endlimit=fg.get("endlimit").value;
            return true;
        }
        else
        {
            return false;
        }
    }
  }

  export interface GoogleLogin
  {
        id:number,  
        access_token:string,
        primary_mail:string,
        calendar_id:string,
        status:number
  }
  
  export interface HTTPGoogleLogin
  {
        id:number,  
        access_token:string,
        primary_mail:string,
        calendar_id:string,
        status:number
  }
  
  export class GoogleLoginForm implements HTTPGoogleLogin{
  
        public id:number;
        public access_token:string;
        public primary_mail:string; 
        public calendar_id:string; 
        public status:number;
  
      constructor(data : GoogleLogin) 
      {
            if(data==null)
            {
                this.id=-1;
                this.access_token="";
                this.primary_mail="";
                this.calendar_id="";
                this.status=-1;
            }
            else
            {
                this.id=-1;
                this.access_token=data.access_token;
                this.primary_mail=data.primary_mail;
                this.calendar_id=data.calendar_id;
                this.status=data.status;
            }
      }
    }